import isNumberInRange from 'utils/isNumberInRange';

function updateMenteeModuleOrder({ menteeModules, menteeModuleId, newOrder }) {
  const menteeModule = menteeModules.find((o) => o.id === menteeModuleId);

  const currentOrder = menteeModule.order;
  // If moving down i.e newOrder > currentOrder then all mentee modules
  // between the new and old order should be moved up by decreasing order
  // by 1.
  // If moving up i.e newOrder < currentOrder then all mentee modules
  // between the new and old order should be moved down by increasing order
  // by 1.
  const moveEffectRowsOrderBy = newOrder > currentOrder ? -1 : 1;

  return menteeModules.reduce((acc, item) => {
    let order = item.order;

    if (item.id === menteeModuleId) {
      order = newOrder;
    } else if (isNumberInRange([currentOrder, newOrder], order)) {
      order += moveEffectRowsOrderBy;
    }

    acc.push({ ...item, order });

    return acc;
  }, []);
}

export default updateMenteeModuleOrder;
